/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Lp pair creation request
 */
export interface LpPairCreateRequest {
  qtyScale: number;
  priceScale: number;
  minQty: number;
  maxQty: number;
  basePairId: number;
  liquidityProviderId: number;
}
